import type { GamePopupProps } from './types';
import { CanonicalGamePopup } from './CanonicalGamePopup';
import { LegacyGamePopup } from './LegacyGamePopup';

export function GamePopup({ url, name, onClose, format = 'canonical' }: GamePopupProps) {
    if (format === 'legacy') {
        return <LegacyGamePopup url={url} name={name} onClose={onClose} />;
    }

    return <CanonicalGamePopup url={url} name={name} onClose={onClose} />;
}
